module.exports = __webpack_public_path__ + "img/32.01001396.jpg";